import React, { useEffect, useState } from "react";
import { CircularProgress, Grid } from "@mui/material";
import Product from "./Product";
import SortContext from "context/SortContext";
import { useFilter } from "context/FilterContext";
import { useDesings } from "../api/get-desings";
import { useLocation, useNavigate } from "react-router-dom";
import { useInView } from "react-intersection-observer";
import { transformData } from "utils/transformdata";
import ProductSkeleton from "components/ui/Skeleton/ProductSkeleton";
import GoToTop from "components/ui/GoToTop";
import { ReactComponent as Background } from "assets/icons/bg.svg";
import debounce from "lodash.debounce";
import InfiniteScroll from "react-infinite-scroll-component";
import { useGlobalContext } from "context/GlobalContext";
import { formatString } from "utils/encodeDecodeStr";
import { usePermissions } from "context/PermissionsContext";
import { findSpecificMenu, findSpecificPage, findSpecificSubMenu, findSpecificSubPage, hasAccessSubPage, isAllowed } from "utils/checkUserRigths";
import DataNotFound from "components/ui/datanotfound/DataNotFound";

const Products = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const permission = usePermissions();

  const { selectedSortValue, sortOptions, search, setSearch } = React.useContext(SortContext);
  const selectedOption = sortOptions.find((option) => option.id == selectedSortValue);
  const selectedSortBY = selectedOption?.sortBy;
  const selectedSortOrder = selectedOption?.order;
  const { filterValues, setFilterCount } = useFilter();
  const {
    setEditCatagoryBtn,
    setEditCatagoryBtnOption,
    setIsEditCatagorySelectValue,
    setIsEditCatagoryData,
    setFilterChangeCount,
    setDisplayCount,
    dynamicfilterCount,
    setFilterChangeDesignCount,
    filterChangeCount,
    filterChangeDesignCount,
    setSearchResultCount,
    setDynamicFilterCount,
    setSearchPlaceHolder,
  } = useGlobalContext();

  // const hasAccessToDesigeClass = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Category", permission), "Design Class"), "edit");
  // const hasAccessToMoveSubCategory = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Category", permission), "Move Sub-Category"), "edit");
  // const hasAccessToMakeType = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Category", permission), "Make Type"), "edit");
  // const hasAccessToRestrictDesigns = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Category", permission), "Restrict Design"), "edit");

  const labourValues = filterValues?.Labour?.map((item) => item.split(" - ")[0]).filter(Boolean);
  const classType = filterValues?.Class;
  const ratio = filterValues && filterValues["Ratio"];
  const diamondPieces = filterValues && filterValues["Diamond Pieces"];
  const diamondWeight = filterValues && filterValues["Diamond Weight"];
  const goldGrossWeight = filterValues && filterValues["Gold Gross-Weight"];
  const goldNetWeight = filterValues && filterValues["Gold Net-Weight"];
  const designInCollections = filterValues && filterValues["Design In Collection"];
  const designInSets = filterValues && filterValues["Design In Sets"];
  const bestSeller = filterValues && filterValues["Best Seller Design"];
  const highestSeller = filterValues && filterValues["Highest Seller"];
  const stockStatus = filterValues && filterValues["Product Page Stock Status"];
  const designCreateDate = filterValues && filterValues["Design Create Date"];
  const isHidden = filterValues && filterValues["Show Hidden Designs"]; // Extract subcategory  name from the pathname if location.state is null
  const subCategoryNameFromPath = location.pathname.split("/")[2];

  // Extract subcategory type name from the pathname if location.state is null
  const subCategoryTypeNameFromPath = location.pathname.split("/").pop();

  const categoryName = location.state?.name[0];
  // const subCategoryName = location.state?.name[1];
  const subCategoryName = location.state?.name[1]?.split("-")[0]?.trim();
  const innerChnages = location?.state?.innerChnages ? location?.state?.innerChnages : false;
  const isEditCatagory = location?.state?.isEditCatagory;
  const updateCatagoryData = location?.state?.updateCatagory;
  const permissions = usePermissions();

  const [categoryData, setCategoryData] = useState([]);

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading, isError, error } = useDesings({
    limit: 30,
    categoryName,
    subCategoryName,
    sortBy: selectedSortBY,
    sortOrder: selectedSortOrder,
    labour: labourValues,
    classType: classType,
    ratio,
    diamondPieces,
    diamondWeight,
    goldGrossWeight,
    goldNetWeight,
    designInCollections,
    designInSets,
    search,
    bestSeller,
    highestSeller,
    stockStatus,
    designCreateDate,
    isHidden:!isHidden,
  });

  // useEffect(() => {
  //   setFilterChangeCount(data?.pages[0]?.totalCount);
  //   setDisplayCount(true);
  //   return () => {
  //     setFilterChangeCount(0);
  //     setDisplayCount(false);
  //   };
  // }, [data]);

  const hasAccessToDesigeClass = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Edit Design"), "design_class");
  const hasAccessToMoveSubCategory = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Edit Design"), "move_sub_category");
  const hasAccessToMakeType = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Edit Design"), "make_type");
  const hasAccessToRestrictDesigns = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Edit Design"), "restrict_design");

  useEffect(() => {
    const allProducts = data?.pages?.flatMap((page) => page?.designs);
    setCategoryData(allProducts);

    setSearchPlaceHolder("Search By Design Number");
    if (search === "") {
      setDynamicFilterCount(true);
    }
    if (dynamicfilterCount) {
      setFilterChangeCount(data?.pages[0]?.totalCount);
      // setFilterChangeDesignCount(data?.pages[0]?.totalDesginCount);
      setSearchResultCount(data?.pages[0]?.totalCount);
    } else {
      setSearchResultCount(data?.pages[0]?.totalCount);
      setFilterChangeCount(filterChangeCount);
      // setFilterChangeDesignCount(filterChangeDesignCount);
    }
    setDisplayCount(true);
    return () => {
      setSearchResultCount(0);
      setFilterChangeCount(0);
      // setFilterChangeDesignCount(0);
      setDisplayCount(false);
      setSearchPlaceHolder("");
    };
  }, [data]);

  useEffect(() => {
    if (!innerChnages) {
      setEditCatagoryBtn(hasAccessToDesigeClass || hasAccessToMoveSubCategory || hasAccessToMakeType || hasAccessToRestrictDesigns);
      setEditCatagoryBtnOption([
        { option: "Design Class", updateHeading: "Update Design Class", view: hasAccessToDesigeClass },
        { option: "Move Sub-Category", updateHeading: "Update Sub-category", view: hasAccessToMoveSubCategory },
        { option: "Make Type", updateHeading: "Update Make Type", view: hasAccessToMakeType },
        { option: "Restrict Designs", updateHeading: "Restrict Design", view: hasAccessToRestrictDesigns },
      ]);
    }

    if (isEditCatagory) {
      setIsEditCatagoryData(JSON.parse(sessionStorage.getItem(updateCatagoryData)));
    }

    return () => {
      setEditCatagoryBtn(false);
      setEditCatagoryBtnOption([]);
      setIsEditCatagorySelectValue(false);
      setIsEditCatagoryData([]);
      setFilterCount(0);
      setSearch("");
      sessionStorage.removeItem("appliedSortValue");
    };
  }, [permissions]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [selectedOption, filterValues]);

  // Update location.state if it's null
  useEffect(() => {
    let totalDesignCount = data?.pages[0]?.totalCount;
    if (!location.state?.name || location.state.name[1].includes("undefined")) {
      navigate(location.pathname, { state: { name: [formatString(subCategoryNameFromPath), `${formatString(subCategoryTypeNameFromPath)} - ${totalDesignCount}`] }, replace: true });
    }
  }, [data]);

  if (isLoading) return <ProductSkeleton count={10} />;

  if (isError) return <div>Error: {error.message}</div>;

  const hasNoResults =
    search &&
    data?.pages?.every(
      (page) => !page?.designs?.length
    );

  if (hasNoResults) return <DataNotFound message={`No results found for "${search}"`} />;

  return (
    <>
      <InfiniteScroll
        dataLength={data?.pages.flatMap((page) => page.designs).length || 0} // Total items loaded
        next={fetchNextPage} // Fetch the next page of designs
        hasMore={!!hasNextPage} // Whether there are more pages to load
        loader={isFetchingNextPage && <CircularProgress sx={{ display: "flex", justifyContent: "center", margin: "20px auto" }} />}
        scrollThreshold={0.8} // Trigger next page when 80% scrolled
        endMessage={<p style={{ textAlign: "center" }}>You have seen it all!</p>}
      >
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          sx={{
            flex: "1 1 1",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: "30px",
            rowGap: "32px",
          }}
          className="Grid-padding"
        >
          {data?.pages?.map((page) =>
            page.designs.map((design) => {
              const transformedProduct = transformData(design);
              return <Product product={transformedProduct} key={design._id} allData={categoryData} />;
            })
          )}
        </Grid>
      </InfiniteScroll>

      <GoToTop />

      {data?.pages?.length === 0 ||
        (!data?.pages.some((page) => page?.designs?.length > 0) && (
          <div
            style={{
              display: "flex",
              textAlign: "center",
              margin: "auto",
              padding: "auto",
              justifyContent: "center",
              alignItems: "center",
              height: "78vh",
            }}
          >
            <Background />
          </div>
        ))}
    </>
  );
};

export default Products;